import React from 'react';
import packageJson from '../../package.json';

const VersionInfo: React.FC = () => {
  return (
    <div className="version-info">
      <small>v{packageJson.version} - Build: {process.env.REACT_APP_BUILD_DATE || 'local'}</small>
    </div>
  );
};

export default VersionInfo;